module.exports = __webpack_public_path__ + "static/media/jackpot-main-background.c69ed679.png";